// extracted by mini-css-extract-plugin
export default {"hitpickingMicroplate":"hitpickingMicroplate-f0VXd"};